import { ConditionChild, DesignData } from '../types';
import { resolveSharedTextField } from '../util/sharedTextFields';

function getVisiblePersonalizationFields(
  design: DesignData | undefined,
  elements: ConditionChild[],
  spreadIndex: number,
) {
  const spread = design?.spreads[spreadIndex];
  const media = new Map(
    spread?.pages.flatMap((page) => page.groups.media || []).map((element) => [element.uuid, element]),
  );
  return elements.filter((child) => {
    if (child.type === 'condition') {
      return !!spread?.conditionGroup?.conditions[child.id];
    }
    const element = media.get(child.id);
    if (!element || element.personalizationLocked) {
      return false;
    }
    return element.type !== 'text' || resolveSharedTextField(design, element, spreadIndex).isLead;
  });
}

export default getVisiblePersonalizationFields;
